module.exports = __webpack_public_path__ + "img/by-city4.caa9bc54.svg";